module.exports = __webpack_public_path__ + "img/eat_out_08.0db5c6e5.jpg";